<style src="./Version.scss" lang="scss" scoped></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="image-logo-container">
      <img src="/static/images/logo.svg" alt="Logo" class="image-logo" />
    </div>
    <div class="text">
      <h2>SGI - versão: {{ version }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Version',
  data() {
    return {
      version: '',
    };
  },
  mounted() {
    this.loadVersion();
  },
  methods: {
    async loadVersion() {
      const getVersion = await this.$store.dispatch('CONTROL-PANEL/GetVersion');
      this.version = getVersion;
    },
  },
};
</script>